import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "p-icon-point" }
const _hoisted_2 = {
  key: 0,
  class: "p-icon-point__default"
}
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconPointDefault = _resolveComponent("IconPointDefault")!

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (_ctx.isDefaultIcon)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createVNode(_component_IconPointDefault, {
            "icon-size": _ctx.iconSize,
            "bg-color": _ctx.bgColor,
            "icon-color": _ctx.iconColor,
            "border-color": _ctx.iconColor
          }, null, 8, ["icon-size", "bg-color", "icon-color", "border-color"])
        ]))
      : (_ctx.isCustomIcon)
        ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            style: _normalizeStyle(_ctx.iconStyleObject),
            class: "p-icon-point__custom"
          }, [
            _createElementVNode("img", {
              src: _ctx.getPoint(),
              alt: ""
            }, null, 8, _hoisted_3)
          ], 4))
        : _createCommentVNode("", true)
  ]))
}